
<div class="flex flex-col ui-gap p-5">

  <span class="flex ui-gap">
    <span>Disable buttons </span>&nbsp;&nbsp;
    <p-toggleswitch [(ngModel)]="disabled" onLabel="Disabled" offLabel="Enabled"></p-toggleswitch>
    <span>Disabled: <b>{{disabled()}}</b>  ⬅️ Not bound directly to buttons, only bound to config property and changes propogate to the buttons.</span>
  </span>

  <ng-container *ngFor="let btn of buttons">

    <!-- One-liner button with config object-->
    <ui-button [config]="btn"></ui-button>

  </ng-container>
</div>
<p-toast key="button-toast" position="center" styleClass="custom-toast"></p-toast>